import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Interface

export interface ButtonBarProps {
  children: React.ReactNode;
  centered: boolean;
}

interface StyledButtonBarProps {
  centered: boolean;
}

// Styles

const StyledButtonBar = styled.div<StyledButtonBarProps>`
  ${({ theme: { space, colors, media }, centered }) => css`
    display: flex;
    gap: ${space.small};
    flex-wrap: wrap;

    ${centered &&
    css`
      justify-content: center;
    `}
  `};
`;

// JSX

export const ButtonBar: FC<ButtonBarProps> = ({ children, centered }) => (
  <StyledButtonBar centered={centered}>{children}</StyledButtonBar>
);

export default ButtonBar;
